export default function (context) {
    const $context = $(context);
    const forceBrandGenderSensitive = $context.find('.forceBrandGenderSensitive');

    if (forceBrandGenderSensitive.length) {
        $context.find('[data-statement-brand-gender-col]').each(function () {
            $(this).removeClass('hide');
        });

        $context.find('[data-warmup-brand-gender-col]').each(function () {
            $(this).removeClass('hide');
        });

        return;
    }

    $context.trigger('toggle-statements-brand-gender-sensitive');
    $context.trigger('toggle-warmups-brand-gender-sensitive');
}
